module.exports = __webpack_public_path__ + "static/pr.d34b5cc3.png";